import React from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Mail, Loader2, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Bandeau global (bas d'écran) : invite à confirmer l'email tant que ce n'est
// pas fait. Masqué pour les comptes Google / déjà vérifiés / non connectés.
// (email_verified est strictement false uniquement pour une inscription email
//  non encore confirmée ; les comptes existants restent masqués.)
export default function EmailVerifyBanner() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [sending, setSending] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  if (!user || user.email_verified !== false || hidden) return null;

  function resend() {
    setSending(true);
    axios.post(`${API_URL}/api/auth/resend-verification`, {}, { withCredentials: true })
      .then(() => { toast.success(t('verifyEmail.resent')); })
      .catch(() => { toast.error(t('verifyEmail.resendError')); })
      .finally(() => setSending(false));
  }

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 bg-[#F59E0B] text-black px-4 py-2.5 flex items-center justify-center gap-3 text-sm shadow-lg" data-testid="email-verify-banner">
      <Mail className="h-4 w-4 shrink-0" />
      <span className="font-medium text-center">{t('verifyEmail.bannerText')}</span>
      <button onClick={resend} disabled={sending} className="font-bold underline flex items-center gap-1 disabled:opacity-50 shrink-0">
        {sending && <Loader2 className="h-3 w-3 animate-spin" />}
        {t('verifyEmail.resend')}
      </button>
      <button onClick={() => setHidden(true)} className="ml-2 shrink-0 opacity-70 hover:opacity-100" aria-label="X">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
